// src/components/UI.js

export function PageHeader({ title, sub, action }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24 }}>
      <div>
        <h1 style={{ color: '#f0f0f1', fontSize: 20, fontWeight: 700, margin: 0 }}>{title}</h1>
        {sub && <p style={{ color: '#a7aaad', fontSize: 13, margin: '4px 0 0' }}>{sub}</p>}
      </div>
      {action}
    </div>
  );
}

export function Card({ children, style = {} }) {
  return (
    <div style={{
      background: '#232323', border: '1px solid #3a3a3a',
      borderRadius: 6, padding: 20, ...style,
    }}>{children}</div>
  );
}

export function StatCard({ icon, label, value, color = '#2271b1' }) {
  return (
    <div style={{
      background: '#232323', border: '1px solid #3a3a3a',
      borderRadius: 6, padding: '16px 20px',
      display: 'flex', alignItems: 'center', gap: 16,
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 6,
        background: color + '20', display: 'flex',
        alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0,
      }}>{icon}</div>
      <div>
        <div style={{ color: '#a7aaad', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px' }}>{label}</div>
        <div style={{ color: '#f0f0f1', fontSize: 24, fontWeight: 700, lineHeight: 1.2 }}>{value}</div>
      </div>
    </div>
  );
}

export function Badge({ status }) {
  const map = {
    approved: { bg: 'rgba(0,163,42,.15)', color: '#00a32a', border: 'rgba(0,163,42,.3)', label: 'Approved' },
    pending:  { bg: 'rgba(219,166,23,.15)', color: '#dba617', border: 'rgba(219,166,23,.3)', label: 'Pending' },
    blocked:  { bg: 'rgba(214,54,56,.15)', color: '#d63638', border: 'rgba(214,54,56,.3)', label: 'Blocked' },
  };
  const s = map[status] || map.pending;
  return (
    <span style={{
      background: s.bg, color: s.color, border: `1px solid ${s.border}`,
      borderRadius: 3, padding: '2px 8px', fontSize: 11, fontWeight: 600,
    }}>{s.label}</span>
  );
}

export function Btn({ onClick, children, variant = 'primary', size = 'sm', disabled }) {
  const variants = {
    primary:  { bg: '#2271b1', color: '#fff', border: 'transparent' },
    danger:   { bg: 'rgba(214,54,56,.12)', color: '#d63638', border: 'rgba(214,54,56,.4)' },
    success:  { bg: 'rgba(0,163,42,.12)', color: '#00a32a', border: 'rgba(0,163,42,.4)' },
    ghost:    { bg: 'transparent', color: '#a7aaad', border: '#3a3a3a' },
  };
  const v = variants[variant];
  const pad = size === 'sm' ? '4px 10px' : '8px 16px';
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: v.bg, color: v.color, border: `1px solid ${v.border}`,
      borderRadius: 4, padding: pad, fontSize: 12, fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .5 : 1,
      transition: 'all .15s', whiteSpace: 'nowrap',
    }}>{children}</button>
  );
}

export function Table({ cols, rows, loading }) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #3a3a3a' }}>
            {cols.map(c => (
              <th key={c} style={{ padding: '10px 12px', color: '#a7aaad', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px', textAlign: 'left', whiteSpace: 'nowrap' }}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={cols.length} style={{ padding: 40, textAlign: 'center', color: '#646970' }}>লোড হচ্ছে...</td></tr>
          ) : rows.length === 0 ? (
            <tr><td colSpan={cols.length} style={{ padding: 40, textAlign: 'center', color: '#646970' }}>কোনো data নেই</td></tr>
          ) : rows.map((r, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #2a2a2a', transition: 'background .1s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#2a2a2a'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              {r}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function TD({ children, mono }) {
  return (
    <td style={{ padding: '10px 12px', color: '#f0f0f1', fontSize: 13, fontFamily: mono ? 'DM Mono, monospace' : 'inherit' }}>
      {children}
    </td>
  );
}

export function SearchBar({ value, onChange, placeholder = 'খুঁজুন...' }) {
  return (
    <div style={{ position: 'relative', width: 260 }}>
      <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#646970', pointerEvents: 'none' }}>🔍</span>
      <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ paddingLeft: 32, width: '100%' }} />
    </div>
  );
}

export function FilterSelect({ value, onChange, options }) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)} style={{ width: 'auto', minWidth: 130 }}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function ConfirmModal({ open, title, msg, onConfirm, onCancel, danger }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999,
    }}>
      <div style={{
        background: '#232323', border: '1px solid #3a3a3a', borderRadius: 8,
        padding: 28, maxWidth: 380, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,.6)',
      }}>
        <h3 style={{ color: '#f0f0f1', margin: '0 0 10px', fontSize: 16 }}>{title}</h3>
        <p style={{ color: '#a7aaad', margin: '0 0 24px', fontSize: 13 }}>{msg}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <Btn onClick={onCancel} variant="ghost">বাতিল</Btn>
          <Btn onClick={onConfirm} variant={danger ? 'danger' : 'primary'}>নিশ্চিত করুন</Btn>
        </div>
      </div>
    </div>
  );
}
